import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GalleryRecord } from 'shared';
import { GalleryService } from '../gallery.service';

@Component({
  selector: 'app-gallery-item-page',
  templateUrl: './gallery-item-page.component.html',
  styleUrls: ['./gallery-item-page.component.scss']
})
export class GalleryItemPageComponent implements OnInit {
  record: GalleryRecord;
  constructor(private activeRoute: ActivatedRoute, private galleryService: GalleryService) {}

  async ngOnInit(): Promise<void> {
    const recordId = this.activeRoute.snapshot.paramMap.get('itemId');
    this.record = await this.galleryService.getGalleryRecordById(recordId);
  }
}
